﻿import { Configurator, OverlayPopup } from "@models";
import { Directive } from "@app/components/directive";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { IConfiguratorScope } from "@app/views/products/configurator.view";
import { Dirs } from "@app/helpers/dirs";
import * as angular from "angular";

interface IOverlayPopupScope extends IConfiguratorScope {
    _overlayPopups: OverlayPopup[];
    close: () => void;
}

@NgComponent({
    token: Token.KbOverlayPopup,
    dependencies: [
    ]
})

export class KbOverlayPopupComponent extends Directive {

    constructor() {
        super();

        this.restrict = "E";
        this.replace = true;
        this.scope = true;



        this.controller = [
            "$scope",
            "$element",
            "$document",
            (
                $scope: IOverlayPopupScope,
                $element: ng.IAugmentedJQuery,
                $document: ng.IDocumentService
            ) => {

                const body = $document.find("body").eq(0);

                // ⭐ MOVE POPUP TO BODY
                body.append($element);

                // cleanup
                $scope.$on("$destroy", () => {
                    $element.remove();
                    body.removeClass("kb-no-scroll");
                });

                // watch selected popup
                $scope.$watch(
                    () => $scope.selected && $scope.selected.overlayPopup,
                    (popup: OverlayPopup) => {
                        if (!popup) return;

                        if (!$scope._overlayPopups) {
                            $scope._overlayPopups = [];
                        }

                        const list = $scope._overlayPopups;
                        const index = list.indexOf(popup);

                        if (index > -1) {
                            list.splice(index, 1);
                        }

                        list.push(popup);
                    }
                );

                $scope.$watch(
                    () => $scope._overlayPopups?.some(p => p.visible),
                    (anyOpen: boolean) => {
                        body.toggleClass("kb-no-scroll", anyOpen);
                    }
                );

                $scope.close = (popup?: OverlayPopup) => {
                    if (!popup) return;
                    if (!popup.enableClose) return;
                    popup.visible = false;
                };
            }
        ];




        this.template = Dirs.component("kb-overlay-popup");

    }
}
